<template>
  <div class="Home-show p-2 probanner" style="background:#fff;">
    <div class="proHomecontainer">
      <div class="Showtitle p-3">
        <h1 class="">{{ $t("Home.proTitle") }}</h1>
        <div class="Titleline"></div>
      </div>

      <div style="margin:20px 0">
        <b-row class="main-product">
          <!-- <div class="col-md-6 left-carousel"> -->
          <b-col class="left-product">
            <div style="margin-top: 0;margin-bottom: 0;">
              <b-carousel
                id="carousel-fade"
                style="text-shadow: 0px 0px 2px #000"
                fade
                indicators
                :interval="4000"
                controls
                img-width="1190"
                img-height="420"
                class="halfswiper"
              >
                <b-carousel-slide
                  class="pro-home-slider"
                  v-for="(items, swiperindex) in swiperImg"
                  :key="swiperindex"
                  :caption="items.txt"
                  :img-src="items.src"
                ></b-carousel-slide>
              </b-carousel>
            </div>
            <!-- </div> -->
          </b-col>
          <b-col class="right-product">
            <!-- <div
            class="corp-desc col-md-6"
            style="margin-top: 0;margin-bottom: 10px;color: #000;"
          > -->
            <b-row class="pro-home">
              <b-col class="pro-col" style="">
                <a :href="'/prodetail/'.concat(homepro1.id)">
                  <b-img :src="homepro1.src" fluid style=" "></b-img>
                </a>
              </b-col>
              <b-col class="pro-col">
                <a :href="'/prodetail/'.concat(homepro2.id)">
                  <b-img :src="homepro2.src" fluid style="float:right"></b-img>
                </a>
              </b-col>
            </b-row>
            <b-row class="pro-home">
              <b-col class="pro-col">
                <a :href="'/prodetail/'.concat(homepro3.id)">
                  <b-img :src="homepro3.src" fluid style=""></b-img>
                </a>
              </b-col>
              <b-col class="pro-col">
                <a :href="'/prodetail/'.concat(homepro4.id)">
                  <b-img :src="homepro4.src" fluid style="float:right"></b-img>
                </a>
              </b-col>
            </b-row>
            <!-- </div> -->
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
export default {
  name: "productBanner",
  data() {
    return {
      swiperImg: [
        { src: require("../../../../static/Updatedimg/M55CNCshow-1.jpg") },
        { src: require("../../../../static/Updatedimg/M55CNCshow-2.jpg") },
        { src: require("../../../../static/Updatedimg/M55CNC.png") },
      ],
      homepro1: {
        src: require("../../../../static/Updatedimg/home-proshow1.png"),
        id: "74",
      },
      homepro2: {
        src: require("../../../../static/Updatedimg/home-proshow2.png"),
        id: "70",
      },
      homepro3: {
        src: require("../../../../static/Updatedimg/home-proshow3.png"),
        id: "72",
      },
      homepro4: {
        src: require("../../../../static/Updatedimg/home-proshow4.png"),
        id: "71",
      },
    };
  },
};
</script>

<style>
.pro-home:nth-child(1) {
  padding-bottom: 5px;
}
.pro-home:nth-child(2) {
  padding-top: 5px;
}
.pro-home:nth-child(1) .pro-col:nth-child(1) img {
  float: left;
  /* padding-left: 10% !important; */
  visibility: hidden;
  animation: left-right 1.5s 1s ease-out forwards;
}
.pro-home:nth-child(1) .pro-col:nth-child(2) img {
  float: left;
  /* padding-right: 10%; */
  visibility: hidden;
  animation: left-right 1.5s 1.8s ease-out forwards;
}
.pro-home:nth-child(2) .pro-col:nth-child(1) img {
  float: left;
  /* padding-left: 10% !important; */
  visibility: hidden;
  animation: left-right 1.5s 2.6s ease-out forwards;
}
.pro-home:nth-child(2) .pro-col:nth-child(2) img {
  float: left;
  /* padding-right: 10%; */
  visibility: hidden;
  animation: left-right 1.5s 3.4s ease-out forwards;
}
</style>
